
<template>
  <v-sheet>
    <v-row>
      <v-col cols="12" xl="6" lg="6" md="12">
        <div ref="sourceChart" style="width:90%; height: 600px; margin-top:40px;"></div>
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="12">
        <div ref="featureChart" style="width:90%; height: 600px; margin-top:40px;"></div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import Highcharts from "highcharts";


export default {
  name: "StatDualSumm",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.renderSourceChart();
    this.renderFeatureChart();
  },
  methods: {
    renderSourceChart() {
      const categories = Object.keys(this.data.source_count);
      const internalCounts = categories.map(c => this.data.source_count[c].internal_id_count);
      const geneCounts = categories.map(c => this.data.source_count[c].gene_id_count);

      Highcharts.chart(this.$refs.sourceChart, {
        chart: { type: "column", animation: false },
        title: { text: "Site and Gene Count Across Different Sources" },
        xAxis: { categories, lineWidth: 1 },
        yAxis: [
          {
            title: { text: "Site ID Count" },
            opposite: false,
            lineWidth: 1,
            gridLineWidth: 0,
            endOnTick: true,
            startOnTick: true,
            maxPadding: 0.1
          },
          {
            title: { text: "Gene ID Count" },
            opposite: true,
            lineWidth: 1,
            endOnTick: true,
            startOnTick: true,
            maxPadding: 0.1
          }
        ],
        legend: { align: "center", verticalAlign: "top" },
        plotOptions: {
          series: { animation: false },
          column: {
            dataLabels: {
              enabled: true,
              style: { fontSize: "10px", fontWeight: "bold" }
            }
          }
        },
        series: [
          {
            name: "Site ID Count",
            data: internalCounts,
            yAxis: 0,
            color: "#1976D2"
          },
          {
            name: "Gene ID Count",
            data: geneCounts,
            yAxis: 1,
            color: "#E53935"
          }
        ],
        exporting: {
          enabled: true,
          scale: 8,
          chartOptions: {
            chart: { width: 600, height: 300 }
          },
          buttons: {
            contextButton: { menuItems: ["downloadPNG", "downloadSVG"] }
          }
        }
      });
    },

    renderFeatureChart() {
      const categories = Object.keys(this.data.feature_count);
      const signatures = categories.map(c => this.data.feature_count[c].signature);
      const sites = categories.map(c => this.data.feature_count[c].site_seq_count);

      Highcharts.chart(this.$refs.featureChart, {
        chart: { type: "column", animation: false },
        title: { text: "Signature Count Statistics" },
        xAxis: { categories, lineWidth: 1 },
        yAxis: [
          {
            title: { text: "15-mer Seq Sites Count" },
            opposite: false,
            lineWidth: 1,
            endOnTick: true,
            startOnTick: true,
            maxPadding: 0.1
          },
          {
            title: { text: "Signatures Count" },
            opposite: true,
            lineWidth: 1,
            endOnTick: true,
            startOnTick: true,
            maxPadding: 0.1
          }
        ],
        legend: { align: "center", verticalAlign: "top" },
        plotOptions: {
          series: { animation: false },
          column: {
            dataLabels: {
              enabled: true,
              style: { fontSize: "10px", fontWeight: "bold" }
            }
          }
        },
        series: [
          {
            name: "15-mer Seq Sites Count",
            data: sites,
            yAxis: 0,
            color: "#43A047"
          },
          {
            name: "Signatures Count",
            data: signatures,
            yAxis: 1,
            color: "#FB8C00"
          }
        ],
        exporting: {
          enabled: true,
          scale: 8,
          chartOptions: {
            chart: { width: 600, height: 300 }
          },
          buttons: {
            contextButton: { menuItems: ["downloadPNG", "downloadSVG"] }
          }
        }
      });
    }

  }
};
</script>
